import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const CertificationBody = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Certification Body – Industrial Research & Training</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) operates a Certification Body under its Industrial Research and Training division to ensure compliance with national and international standards.
          </p>
          <p className="subtitle">
            The Certification Body provides certification services for management systems, products, and personnel, promoting quality, safety, and competitiveness in Malawi.
          </p>
        </div>
      </section>

      {/* === Certification Services Section === */}
      <section className="intro-section">
        <h2 className="section-title">Certification Services Offered</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Management systems certification (ISO 9001, ISO 14001, ISO 45001)</li>
              <li>Product certification for quality, safety, and compliance</li>
              <li>Personnel certification for technical and professional competencies</li>
              <li>Accreditation support for laboratories and inspection bodies</li>
              <li>Capacity building and training on certification procedures</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Audit and assessment of organizational processes</li>
              <li>Evaluation of compliance with national and international standards</li>
              <li>Technical consultancy on certification readiness</li>
              <li>Monitoring and surveillance of certified organizations</li>
              <li>Continuous improvement and support for certified entities</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Certification Process Section === */}
      <section className="functions-section">
        <h2 className="section-title">Certification Process</h2>
        <p>
          Organizations and individuals seeking certification undergo a structured process including application, assessment, audit, and review. 
          Successful applicants are awarded certification that is recognized nationally and internationally.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Certification Services</h2>
        <p>
          For inquiries, applications, or further information about certification services, please contact the Industrial Research and Training Certification Body at MBS.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:certification@mbs.mw">certification@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 777</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          The MBS Certification Body ensures organizations and personnel meet required standards, enhancing quality, safety, and competitiveness in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default CertificationBody;

